/* DEMO product page sale styling (29 Oct): a SALE tag at the top right of the picture, and the Was price + a green "Save x%" tag beside the orange price. The picture counter moves to the top left to make room. Also stops the first thumbnail being cut off. Tidy-up (29 Oct): the grey summary box under the title is hidden (the Description tab has it), and the size-strip prices are brown so only the main price and ADD are orange. Undo = delete this file and its line in snippets/oldIE-js.liquid. */
(function () {
  'use strict';
  var det = document.getElementById('product-details'), imgs = document.getElementById('product-images');
  if (!det || !imgs) return;
  function $(s, r) { return (r || document).querySelector(s); }

  var css = document.createElement('style');
  css.textContent = '#product-images .dc-gcount{right:auto!important;left:10px!important}' +
    '#product-details .dc-sum{display:none!important}' +
    '#dc-sizes .dc-sz-p b{color:#392919!important}' +
    '#product-images .dc-sale{position:absolute;z-index:4;top:10px;right:10px;padding:7px 15px;border-radius:999px;background:#eb6035;color:#fff;font:800 13px/1 Arial,Helvetica,sans-serif;letter-spacing:.8px;pointer-events:none}' +
    '#product-images .dc-thumbs{justify-content:flex-start!important}#product-images .dc-thumbs>:first-child{margin-left:auto}#product-images .dc-thumbs>:last-child{margin-right:auto}' +
    '#product-details .dc-pricerow{display:flex;align-items:center;flex-wrap:wrap;gap:4px 12px}' +
    '#product-details .dc-pricerow #ProductPrice{order:1}' +
    '#product-details .dc-pricerow #ComparePrice{order:2;float:none!important;width:auto!important;margin:0!important;font-size:16px;color:#8c7762}' +
    '#product-details .dc-pricerow .dc-save{order:3;display:inline-block;padding:3px 10px;border-radius:6px;background:#e6f3e8;color:#2f7d39;font:700 13px/18px Arial,Helvetica,sans-serif;white-space:nowrap}' +
    '#product-details .dc-pricerow .dc-save[hidden],#product-details .dc-pricerow .dc-save:empty{display:none!important}';
  document.head.appendChild(css);

  var prices = $('.product-single__prices', det), P = $('#ProductPrice'), C = $('#ComparePrice');
  if (!prices || !P) return;
  var row = document.createElement('div'); row.className = 'dc-pricerow';
  prices.insertBefore(row, prices.firstChild);
  row.appendChild(P);
  if (C) row.appendChild(C);
  var save = document.createElement('span'); save.className = 'dc-save'; save.hidden = true; row.appendChild(save);
  var stage = $('.dc-stage', imgs), tag = null;

  function num(t) { var m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : 0; }
  function update() {
    var p = num(P.textContent), c = C ? num(C.textContent) : 0;
    var on = !!(C && c > p && p > 0);
    save.hidden = !on;
    save.textContent = on ? 'Save ' + Math.round((c - p) / c * 100) + '%' : '';
    if (on && !tag && stage) { tag = document.createElement('span'); tag.className = 'dc-sale'; tag.textContent = 'SALE'; stage.appendChild(tag); }
    if (tag) tag.style.display = on ? '' : 'none';
  }
  update();
  if (window.MutationObserver) {
    var mo = new MutationObserver(update);
    mo.observe(P, { childList: true, subtree: true, characterData: true });
    if (C) mo.observe(C, { childList: true, subtree: true, characterData: true });
  }
})();